import { render, staticRenderFns } from "./ChatNotification.vue?vue&type=template&id=ba446a28&scoped=true"
import script from "./ChatNotification.vue?vue&type=script&lang=js"
export * from "./ChatNotification.vue?vue&type=script&lang=js"
import style0 from "./ChatNotification.vue?vue&type=style&index=0&id=ba446a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba446a28",
  null
  
)

export default component.exports